import { type Messages } from ".";

export const messagesPT: Messages = {
  HOME: {
    TITLE: "Painel",
    ROUTE: "/dashboard",
    PAGE: "Bem-vindo ao DASF",
    INTRO: "Uma estrutura poderosa para avaliação da gestão de catástrofes",
    SECTION1_TITLE: "Funcionalidades",
    SECTION1:
      "Esta aplicação apoia a avaliação de capacidades na gestão de catástrofes.",
    SECTION2_TITLE: "Tecnologia",
    SECTION2: "Construído com TypeScript e tecnologias web modernas.",
    SECTION3_TITLE: "Utilização",
    SECTION3: "Navegue pelas secções utilizando a barra de navegação.",
  },
  ABOUT: {
    TITLE: "Sobre",
    ROUTE: "/about",
    PAGE: "Sobre o DASF",
    INTRO: "Saiba mais sobre o DIREKTION Assessment & Screening Framework",
    SECTION1_TITLE: "O que é o DASF",
    SECTION1:
      "O DIREKTION Assessment & Screening Framework ajuda organizações na gestão de catástrofes.",
    SECTION2_TITLE: "Características principais",
    SECTION2:
      "Avaliação de capacidades, identificação de lacunas, avaliação de soluções e roteiro.",
    SECTION3_TITLE: "Objetivos de desenvolvimento",
    SECTION3:
      "Fornecer uma estrutura clara e manutenível para a gestão de catástrofes.",
  },
  SETTINGS: {
    TITLE: "Definições",
    ROUTE: "/settings",
    PAGE: "Definições da aplicação",
    INTRO: "Configure as suas preferências de aplicação",
    SECTION1_TITLE: "Preferências de idioma",
    SECTION1: "Mude entre os idiomas disponíveis.",
    SECTION2_TITLE: "Definições de aparência",
    SECTION2: "Personalize a aparência visual da aplicação.",
    SECTION3_TITLE: "Preferências",
    SECTION3: "Gira o comportamento da aplicação.",
  },
  LANDING: { TITLE: "Introdução", ROUTE: "/" },
  HAZARDS: { TITLE: "Ameaças", ROUTE: "/hazards" },
  SOLUTIONS: { TITLE: "Soluções", ROUTE: "/solutions" },
  ROADMAP: { TITLE: "Roteiro", ROUTE: "/roadmap" },
  USER: "Utilizador",
  EDITOR: "Editor",
  ADMIN: "Administrador",
  CANCEL: "Cancelar",
  DELETE: "Eliminar",
  YES: "Sim",
  NO: "Não",
  OK: "OK",
  NAME: "Nome",
  DESCRIPTION: "Descrição",
  DELETE_ITEM: {
    TITLE: "Eliminar {item}",
    DESCRIPTION:
      "Tem a certeza de que pretende eliminar este {item}? Não é possível reverter.",
  },
  SAVE_BUTTON: {
    LABEL: "Guardar",
    TOOLTIP: "Guardar alterações não guardadas",
  },
  SEARCH: "Pesquisar...",
  SEARCH_TOOLTIP: "Escreva / para pesquisar",
  LANGUAGE: "Idioma",
  CLEAR: "Limpar modelo",
  UPLOAD: "Carregar modelo como JSON",
  DOWNLOAD: "Descarregar modelo como JSON",
  PERMALINK: "Criar ligação permanente",
  ROLE: "Função",
  LINK: "Ligação",
  MODEL: "Modelo",
  TITLE: "Título",
  AUTHORS: "Autores",
  TYPE: "Tipo",
  HITS: {
    n: "{n} Resultados",
  },
  NO_RESULTS: "Nenhum resultado encontrado",
  CLEAR_SEARCH: "Limpar pesquisa",
  PAGE_NOT_FOUND: "Página não encontrada",

  about_route: "/about",
  about: "Sobre",
  acronym: "Acrónimo",
  add_term: "Adicionar um novo termo",
  addr_how: "Como é abordado?",
  addressed: "Abordado",
  ass_instr:
    "_Avalie a contribuição de uma capacidade para os seus objetivos._",
  ass_label: "A causa do problema é bem conhecida",
  ass_overall: "Necessidade de melhoria",
  ass_scale: "Escala para a pontuação de avaliação",
  ass_setting: "Matriz de avaliação",
  ass: "Avaliação",
  assess_content:
    "Determine para cada capacidade a sua importância e o desempenho atual.",
  assess: "Avaliar",
  assessment_route: "/assessment/:id",
  assessment: "Avaliação",
  avg_perf: "Avaliação geral",
  cap_cat: "Categoria de capacidade",
  cap: "Capacidade",
  caps: "Capacidades",
  cat: "Categoria",
  clear_all: "Limpar todos os filtros",
  clear: "Limpar",
  color: "Cor",
  create_cap: "Criar capacidade",
  defs: "Definições",
  del_model: "Tem a certeza de que pretende eliminar tudo?",
  del_model_desc: "Tem a certeza de que pretende eliminar o seu modelo?",
  del_proj: "Eliminar projeto",
  desc_cap_instr: "Descreva a capacidade em detalhe.",
  desc: "Descrição",
  develop_content: "Comece a desenvolver as suas capacidades.",
  develop: "Desenvolver",
  development: "Desenvolvimento",
  development_route: "/development/:id",
  dev_cap:
    "_Sugira novos projetos para desenvolver a sua capacidade. Comece por selecionar uma capacidade._",
  doc_id: "ID do documento",
  doc: "Documentação",
  download: "Descarregar",
  duration: "Duração",
  edit: "Editar",
  view: "Ver",
  evaluation_route: "/evaluation/:id",
  evaluation: "Avaliação",
  exp_perf: "Desempenho esperado",
  expl: "Explicação",
  expl2: "Desempenho",
  filter_cap: "Filtrar capacidades",
  filter_caps: "Filtrar capacidades",
  filter_ph: "Título ou descrição",
  filter_text_ph: "Termo ou descrição",
  filter_text: "Texto do filtro",
  filters: "Filtros",
  relevance: "Relevância",
  gap_scale: "Escala para a lacuna",
  gap_settings: "##### Definições de lacunas",
  gap: "Lacuna",
  gaps_common: "Lacunas comuns ou causas de problemas",
  gaps: "Lacunas",
  gng: "###### Decisão GO / NO GO<br>",
  go: "GO",
  goal_scale: "Escala para os temas de avaliação",
  goals_instr: "Especificar objetivos a longo e curto prazo",
  goal: "Objetivo",
  goals: "Objetivos",
  group_goals_instr:
    "1. **Defina os objetivos de grupo que pretende alcançar.**\n2. Especifique as suas partes interessadas e os seus objetivos organizacionais.\n3. Especifique categorias de capacidades para organizar as capacidades.\n4. Especifique as capacidades necessárias para alcançar os objetivos de grupo.",
  group_goals: "Especificar objetivos de grupo",
  home_route: "/",
  home: "INÍCIO",
  id: "ID",
  importance: "Importância",
  in_months: "Em meses",
  loc: "Sala/localização",
  main_goals: "Objetivos",
  assess_capability_importance_for_capability:
    'Avalie a importância de "{capability}" para o âmbito escolhido.',
  max_imp: "Contribuição máxima",
  name: "Nome",
  no_go: "NO GO",
  no: "Não",
  org_dept: "Organização / Departamento",
  overview_route: "/overview",
  overview: "Visão geral",
  level: "Nível",
  perf_asp: "Aspeto de desempenho",
  perf_asps: "Aspetos de desempenho",
  assess_performance_aspects_for_capability:
    "Avalie os aspetos de desempenho de {capability}.",
  perf_effectiveness_tooltip: "Quão eficaz é {capability}?",
  perf_safety_professionals_tooltip:
    "Qual é o nível de segurança física e mental do pessoal operacional que trabalha em {capability}?",
  perf_efficiency_tooltip: "Quão eficiente é {capability}?",
  perf_scale: "Escala para pontuação de desempenho",
  perf_settings: "##### Definições de avaliação",
  perf: "Desempenho",
  period: "AAAA T1 ou AAAA M1",
  permalink: "Ligação permanente",
  pers_inv: "Pessoas envolvidas",
  pick_more: "Escolher um ou mais",
  pick_one: "Escolher um",
  prep_content: "_Defina os objetivos da sua organização._",
  preparation_route: "/objetivos",
  preparation: "Objetivos",
  prepare_content: "Crie ou selecione as capacidades importantes.",
  prepare: "Preparar",
  prob_areas: "Áreas problemáticas",
  gap_problem_categories_intro:
    "Analise esta lacuna de capacidade nas seguintes categorias de problemas.",
  gap_likert_severity: "Severidade",
  gap_likert_severity_start_label: "Muito baixa",
  gap_likert_severity_middle_label: "Média",
  gap_likert_severity_end_label: "Muito alta",
  gap_likert_probability: "Probabilidade",
  gap_likert_probability_start_label: "Sem alteração",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Grande redução",
  gap_likert_impact: "Impacto",
  gap_likert_impact_start_label: "Sem alteração",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Grande redução",
  gap_likert_severity_tooltip:
    "Como avalia a severidade desta lacuna de capacidade?",
  gap_likert_probability_tooltip:
    "Suponha que a lacuna seja resolvida: o que significaria isto para a probabilidade de ocorrência da lacuna?",
  gap_likert_impact_tooltip:
    "Suponha que a lacuna seja resolvida. O que significaria isto para a redução do impacto da lacuna original?",
  prob: "Problema",
  proj_app: "###### PROJETO APROVADO<br>",
  proj_name: "Nome do projeto",
  proj_prop: "Novo projeto ou proposta",
  proj_sum: "Resumo do projeto",
  prop_name: "Nome da proposta",
  prop_new: "Nova proposta",
  ref: "Referência",
  ref_url: "URL de referência",
  select_cap: "Selecionar capacidade",
  select_cat: "Selecionar categoria",
  select_m_ph: "Selecionar um ou mais",
  select_subcat: "Selecionar subcategoria",
  settings_route: "/settings",
  settings: "Definições",
  sh_filter: "Filtrar organizações envolvidas",
  sh_org: "Organizações partes interessadas",
  sh_settings: "##### Definições de partes interessadas",
  sh_type: "Tipo de parte interessada",
  sh_types: "Tipos de partes interessadas",
  sh: "Parte interessada",
  shs: "Partes interessadas",
  other_stakeholder: "Por favor descreva a outra parte interessada",
  spec_cap_instr:
    "1. Defina os objetivos de grupo que pretende alcançar.\n2. Especifique as suas partes interessadas e os seus objetivos organizacionais.\n3. Especifique categorias de capacidades para organizar as capacidades.\n4. **Especifique as capacidades necessárias para alcançar os objetivos de grupo.**",
  spec_cap: "Especificar capacidades",
  spec_cat_instr:
    "1. Defina os objetivos de grupo que pretende alcançar.\n2. Especifique as suas partes interessadas e os seus objetivos organizacionais.\n3. **Especifique categorias de capacidades para organizar as capacidades.**\n4. Especifique as capacidades necessárias para alcançar os objetivos de grupo.",
  spec_cat: "Especificar categorias",
  spec_sh_instr:
    "1. Defina os objetivos de grupo que pretende alcançar.\n2. **Especifique as suas partes interessadas e os seus objetivos organizacionais.**\n3. Especifique categorias de capacidades para organizar as capacidades.\n4. Especifique as capacidades necessárias para alcançar os objetivos de grupo.",
  spec_sh: "Especificar partes interessadas",
  start_time: "Hora de início",
  subcat: "Subcategoria",
  task_settings: "##### Definições de tarefas",
  task: "Tarefa",
  task2perf: "##### Tabela de correspondência tarefa-desempenho",
  tasks: "Tarefas",
  ass_task_scale: "Escala de tarefas",
  ass_perf_scale: "Desempenho",
  taxonomy_route: "/taxonomy",
  taxonomy: "Taxonomia",
  tax_def: "#### Taxonomia\n\nDefinições e abreviações de termos de uso comum.",
  TAXONOMY: {
    HAZARD: "Ameaça",
    HAZARD_DEF:
      "Um processo, fenómeno ou atividade humana que pode causar perda de vidas, lesões, perturbações ou danos ambientais.",
    HAZARD_TYPE: "Tipo de ameaça",
    HAZARD_TYPE_DEF:
      "Uma classe de ameaças com origem ou características semelhantes, como ameaças naturais, tecnológicas ou de origem humana.",
    DISASTER: "Catástrofe",
    DISASTER_DEF:
      "Uma perturbação grave de uma comunidade ou sociedade que excede a sua capacidade para fazer face com os seus próprios recursos.",
    EMERGENCY: "Emergência",
    EMERGENCY_DEF:
      "Uma situação que requer ação coordenada imediata para proteger a vida, a saúde, os bens ou o ambiente.",
    DISASTER_RISK: "Risco de catástrofe",
    DISASTER_RISK_DEF:
      "O potencial de perdas por eventos perigosos, determinado pela ameaça, exposição, vulnerabilidade e capacidade.",
    EXPOSURE: "Exposição",
    EXPOSURE_DEF:
      "A presença de pessoas, bens, infraestruturas e serviços em locais onde podem ocorrer ameaças.",
    VULNERABILITY: "Vulnerabilidade",
    VULNERABILITY_DEF:
      "Condições que aumentam a suscetibilidade de pessoas, bens ou sistemas aos impactos das ameaças.",
    CAPACITY: "Capacidade",
    CAPACITY_DEF:
      "As forças e recursos disponíveis para antecipar, fazer face, resistir e recuperar dos impactos das ameaças.",
    CAPABILITY: "Aptidão",
    CAPABILITY_DEF:
      "Uma capacidade específica e demonstrável de uma organização para realizar tarefas e alcançar resultados em condições definidas.",
    RESILIENCE: "Resiliência",
    RESILIENCE_DEF:
      "A capacidade dos sistemas e comunidades para resistir, absorver, adaptar e recuperar enquanto preservam as funções essenciais.",
    PREVENTION: "Prevenção",
    PREVENTION_DEF:
      "Ações para evitar a criação de novos riscos e impedir que as ameaças causem impactos prejudiciais.",
    MITIGATION: "Mitigação",
    MITIGATION_DEF:
      "Medidas que reduzem a gravidade ou probabilidade de impactos adversos de eventos perigosos.",
    PREPAREDNESS: "Preparação",
    PREPAREDNESS_DEF:
      "Conhecimentos, planos e capacidades desenvolvidos antecipadamente para permitir uma antecipação, resposta e recuperação eficazes.",
    EARLY_WARNING_SYSTEM: "Sistema de alerta precoce",
    EARLY_WARNING_SYSTEM_DEF:
      "Um sistema integrado para monitorizar ameaças, avaliar riscos, comunicar alertas e permitir ações atempadas.",
    RESPONSE: "Resposta",
    RESPONSE_DEF:
      "Ações tomadas imediatamente antes, durante ou após um evento para salvar vidas e atender necessidades urgentes.",
    RECOVERY: "Recuperação",
    RECOVERY_DEF:
      "O processo de restauração e melhoria dos meios de subsistência, serviços, infraestruturas e sistemas após uma catástrofe.",
    BUILD_BACK_BETTER: "Reconstruir melhor",
    BUILD_BACK_BETTER_DEF:
      "Usar a recuperação e reconstrução para reduzir riscos futuros e melhorar a resiliência além das condições pré-catástrofe.",
    CONTINGENCY_PLANNING: "Planificação de contingência",
    CONTINGENCY_PLANNING_DEF:
      "Preparação de planos operacionais específicos e modalidades de coordenação para cenários de emergência plausíveis.",
    RISK_ASSESSMENT: "Avaliação de riscos",
    RISK_ASSESSMENT_DEF:
      "Um processo estruturado para identificar ameaças, analisar consequências e estimar riscos para apoiar decisões.",
    RISK_COMMUNICATION: "Comunicação de riscos",
    RISK_COMMUNICATION_DEF:
      "Troca bidirecional de informações sobre riscos entre autoridades, intervenientes, partes interessadas e o público.",
    SITUATION_AWARENESS: "Consciência situacional",
    SITUATION_AWARENESS_DEF:
      "Uma compreensão atual e partilhada das condições do incidente, impactos, recursos e desenvolvimentos prováveis.",
    INCIDENT_COMMAND: "Comando de incidente",
    INCIDENT_COMMAND_DEF:
      "Uma estrutura de comando e coordenação para gerir funções, decisões e recursos durante incidentes.",
    STAKEHOLDER: "Parte interessada",
    STAKEHOLDER_DEF:
      "Qualquer organização, grupo ou indivíduo com um papel, responsabilidade ou interesse na preparação, resposta ou recuperação.",
    INTEROPERABILITY: "Interoperabilidade",
    INTEROPERABILITY_DEF:
      "A capacidade de organizações, equipas e sistemas para trabalhar juntos eficazmente através de procedimentos, dados e tecnologia.",
    CAPABILITY_GAP: "Lacuna de capacidade",
    CAPABILITY_GAP_DEF:
      "A diferença entre os níveis de capacidade necessários e atuais para alcançar os resultados pretendidos.",
    CAPABILITY_ASSESSMENT: "Avaliação de capacidades",
    CAPABILITY_ASSESSMENT_DEF:
      "Uma avaliação estruturada da importância e desempenho das capacidades para identificar prioridades de melhoria.",
    SOLUTION: "Solução",
    SOLUTION_DEF:
      "Uma medida, prática, tecnologia ou intervenção proposta para colmatar uma ou mais lacunas de capacidade.",
    SOLUTION_ASSESSMENT: "Avaliação de soluções",
    SOLUTION_ASSESSMENT_DEF:
      "Uma apreciação sistemática de soluções candidatas face às necessidades dos utilizadores, adequação operacional, impacto e conformidade.",
    ROADMAP: "Roteiro",
    ROADMAP_DEF:
      "Um plano de implementação faseado que mostra o que será entregue, por quem e quando.",
    IMPLEMENTATION_TIMELINE: "Cronograma de implementação",
    IMPLEMENTATION_TIMELINE_DEF:
      "A sequência e calendário planeados de atividades, marcos e resultados para a implementação.",
    PRIORITIZATION: "Priorização",
    PRIORITIZATION_DEF:
      "Classificação de ações ou investimentos com base na urgência, impacto esperado, viabilidade e recursos disponíveis.",
    MONITORING_EVALUATION: "Monitorização e avaliação",
    MONITORING_EVALUATION_DEF:
      "Acompanhamento contínuo e revisão periódica do progresso, resultados e eficácia para apoiar a aprendizagem e o ajustamento.",
    LESSONS_LEARNED: "Lições aprendidas",
    LESSONS_LEARNED_DEF:
      "Conhecimentos documentados de operações e exercícios utilizados para melhorar o planeamento e o desempenho futuros.",
    SESSION: "Sessão de avaliação",
    SESSION_DEF:
      "Um contexto de trabalho guardado contendo ameaças selecionadas, avaliações, soluções e dados do roteiro.",
    COMPLIANCE_CHECK: "Verificação de conformidade",
    COMPLIANCE_CHECK_DEF:
      "Uma verificação de que as soluções e ações propostas cumprem os requisitos legais, políticos, éticos e setoriais.",
    TECHNOLOGY_READINESS_LEVEL: "Nível de maturidade tecnológica",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "Uma escala de 1 a 9 que indica a maturidade de uma tecnologia desde o conceito até ao implantação operacional.",
  },
  term: "Termo",
  title: "Título",
  upload: "Carregar",
  url: "URL",
  value: "Valor",
  yes: "Sim",
  TBD: "Desconhecido",
  general_settings: "Geral",
  enable_sol_ass_support: "Avaliação de soluções ativada",
  logo: "Logótipo do utilizador",
  attribution_logo: "Logótipo de atribuição",
  attribution_text: "Texto de atribuição",
  order: "Ordem",
  hide: "Ocultar na visão geral",
  select_user: "Selecionar utilizador",
  user: "Utilizador padrão",
  moderator: "Moderador",
  admin: "Administrador",
  doc_title: "Relatório de avaliação de capacidades",
  export_to_word: "Exportar para Word",
  export_all_to_word: "Exportar relatório completo para Word",
  add_gap: "Adicionar lacuna de capacidade",
  ignore: "Não aplicável",
  continue: "Continuar",
  hazards: "Ameaças",
  hazards_route: "/hazards",
  hazard_step_title: "Passo 0: Iniciação e Preparação",
  hazard_step_desc:
    "Selecione os tipos de ameaças relevantes para o âmbito que deseja abordar neste workshop de avaliação.",
  workshop_scope: "Âmbito do workshop",
  hazard_category_all: "Todos",
  hazard_category_natural: "Natural",
  hazard_category_technical: "Técnico",
  hazard_category_attack: "Ataque",
  hazard_edit: "Editar tipos de ameaças",
  hazard_done: "Terminar edição",
  hazard_add: "Adicionar novo tipo de ameaça",
  hazard_name: "Nome da ameaça",
  hazard_description: "Descrição / contexto",
  hazard_selected_count: "{n} tipo(s) de ameaça selecionado(s).",
  solutions: "Soluções",
  solution_count: {
    1: "1 solução",
    n: "{n} soluções",
  },
  solutions_route: "/solutions",
  solutions_step_title: "Passo 2: Avaliação de soluções",
  solutions_step_desc:
    "Adicionar e avaliar soluções para as lacunas identificadas.",
  solution_add: "Adicionar solução",
  solution_new: "Nova solução",
  solution_gaps_found: {
    1: "1 lacuna de capacidade identificada",
    n: "{n} lacunas de capacidade identificadas",
  },
  solution_empty:
    "Ainda não foram adicionadas soluções. Clique em 'Adicionar solução' para começar.",
  roadmap: "Roteiro",
  roadmap_count: {
    1: "1 item do roteiro",
    n: "{n} itens do roteiro",
  },
  roadmap_route: "/roadmap",
  roadmap_step_title: "Passo 3: Roteiro",
  roadmap_step_desc: "Planear cronogramas de implementação e compromissos.",
  roadmap_add_solutions: "Adicionar {n} solução/ões ao roteiro",
  roadmap_empty_solutions:
    "Conclua primeiro o passo 2 (Avaliação de soluções) para adicionar soluções ao roteiro.",
  roadmap_empty: "Nenhum item no roteiro.",
  roadmap_timeline: "Cronograma",
  session_create: "Criar",
  session_new_name: "Nome da nova sessão",
  session_sessions: "Sessões de avaliação",
  session_name: "Nome",
  session_updated: "Última atualização",
  session_actions: "Ações",
  session_clone: "Clonar sessão",
  session_download: "Descarregar como JSON",
  session_delete: "Eliminar sessão",
  session_import: "Importar JSON",
  session_delete_confirm: "Eliminar sessão: {name}?",
  session_delete_warning: "Esta ação não pode ser revertida. Tem a certeza?",
  dashboard_subtitle:
    "Siga os passos abaixo para concluir a avaliação de gestão de catástrofes.",
  back_to_sessions: "Voltar às sessões",
  step0_title: "Iniciação e Preparação",
  step1_title: "Avaliação de necessidades e lacunas",
  step2_title: "Avaliação de soluções",
  step3_title: "Roteiro",
  summary: "Resumo",
  selected_hazards: "Ameaças selecionadas",
  capability_gaps: "Lacunas de capacidade",
  more: "mais",
  partially: "Parcialmente",
  not_assessed: "Não avaliado",
  enabled_steps: "Passos ativados",
  priority_low: "Baixo",
  priority_medium: "Médio",
  priority_high: "Alto",
  sol_trl: "Nível de maturidade tecnológica",
  trl1: "Princípios básicos observados",
  trl2: "Conceito tecnológico formulado",
  trl3: "Prova de conceito experimental",
  trl4: "Tecnologia validada em laboratório",
  trl5: "Tecnologia validada em ambiente relevante",
  trl6: "Tecnologia demonstrada em ambiente relevante",
  trl7: "Protótipo de sistema demonstrado em ambiente operacional",
  trl8: "Sistema completo e qualificado",
  trl9: "Sistema real comprovado em ambiente operacional",
  sol_integration_rl: "Nível de prontidão para integração",
  sol_societal_rl: "Nível de prontidão societal",
  sol_manufacturing_rl: "Nível de prontidão de fabrico",
  sol_commercialisation_rl: "Nível de prontidão para comercialização",
  sol_security_rl: "Nível de prontidão de segurança",
  sol_legal_privacy_ethical_rl:
    "Nível de prontidão jurídica, de privacidade e ética",
  integration_rl1:
    "Foi identificado um conceito de alto nível para a integração",
  integration_rl2:
    "Existe algum nível de especificidade dos requisitos para a interação entre componentes",
  integration_rl3:
    "O desenho detalhado de integração foi definido para incluir todos os detalhes da interface",
  integration_rl4:
    "Validação das funções dos componentes integrados em ambiente laboratorial",
  integration_rl5: "Validação dos componentes integrados em ambiente relevante",
  integration_rl6:
    "Validação dos componentes integrados em ambiente relevante de ponta a ponta",
  integration_rl7:
    "Demonstração da integração do protótipo em ambiente operacional de alta fidelidade",
  integration_rl8: "Teste e demonstração em ambiente operacional",
  integration_rl9:
    "Integração do sistema comprovada através de capacidades operacionais de missão bem-sucedidas",
  societal_rl1:
    "Identificação da necessidade societal genérica, do bem social e dos aspetos associados",
  societal_rl2:
    "Formulação do conceito de solução proposto e dos impactos potenciais",
  societal_rl3:
    "Um grupo limitado da sociedade conhece a solução ou iniciativas semelhantes",
  societal_rl4:
    "Um grupo limitado da sociedade testa a solução ou iniciativas semelhantes",
  societal_rl5:
    "A sociedade conhece a solução ou iniciativas semelhantes, mas não está consciente dos seus benefícios",
  societal_rl6:
    "A sociedade conhece a solução e aumenta a consciencialização para os seus benefícios",
  societal_rl7:
    "A sociedade está totalmente consciente dos benefícios da solução",
  societal_rl8:
    "A sociedade está pronta para adotar a solução e utilizou soluções semelhantes no mercado",
  societal_rl9:
    "A sociedade está a utilizar a solução e esta é apoiada pelas partes interessadas e pelo público",
  manufacturing_rl1: "Implicações básicas de fabrico identificadas",
  manufacturing_rl2: "Conceitos de fabrico identificados",
  manufacturing_rl3: "Prova de conceito de fabrico desenvolvida",
  manufacturing_rl4:
    "Capacidade para produzir a tecnologia em ambiente laboratorial",
  manufacturing_rl5:
    "Capacidade para produzir os componentes protótipo em ambiente relevante para a produção",
  manufacturing_rl6:
    "Capacidade para produzir um protótipo de sistema ou subsistema em ambiente relevante para a produção",
  manufacturing_rl7:
    "Capacidade para produzir sistemas, subsistemas ou componentes em ambiente representativo da produção",
  manufacturing_rl8:
    "Capacidade de linha piloto demonstrada. Pronto para iniciar produção de baixo ritmo",
  manufacturing_rl9:
    "Produção de baixo ritmo demonstrada. Capacidade instalada para iniciar produção a ritmo total",
  commercialisation_rl1: "Investigação e hipótese de base",
  commercialisation_rl2: "Avaliação de mercado",
  commercialisation_rl3: "Validação da aplicação tecnológica e do mercado",
  commercialisation_rl4: "Proposta de valor",
  commercialisation_rl5:
    "Desenvolvimento do produto e alinhamento com o mercado",
  commercialisation_rl6:
    "Otimização do produto/solução e proteção da propriedade intelectual",
  commercialisation_rl7: "Validação técnica e comercial",
  commercialisation_rl8:
    "Estratégia de comercialização e introdução no mercado",
  commercialisation_rl9: "Lançamento completo e receitas de licenciamento",
  security_rl1: "Consideração de segurança",
  security_rl2: "Desenvolvimento do conceito de segurança",
  security_rl3: "Segurança by design",
  security_rl4: "Preparação de medidas e funcionalidades de segurança",
  security_rl5: "Validação simples de segurança",
  security_rl6: "Demonstração sequencial de segurança",
  security_rl7: "Demonstrações complexas de segurança",
  security_rl8: "Validação final de segurança pré-lançamento e preparação",
  security_rl9: "Segurança operacional inicial",
  security_rl10: "Segurança bem estabelecida/fiável",
  legal_privacy_ethical_rl1:
    "Controlo sobre questões legais, éticas e de privacidade: o sistema implementou mecanismos de controlo para responsabilização e passou referências padrão e obteve certificação, quando aplicável",
  legal_privacy_ethical_rl2:
    "Tensões éticas resolvidas através de ethics-by-design: as considerações legais, éticas e de privacidade do sistema foram concebidas para serem compatíveis entre si. As tensões éticas foram tratadas para que a melhoria de um aspeto não afete negativamente outro",
  legal_privacy_ethical_rl3:
    "Interações legais, éticas e de privacidade caracterizadas: as interações entre diferentes considerações éticas e de privacidade foram caracterizadas",
  legal_privacy_ethical_rl4:
    "Questões legais, éticas e de privacidade identificadas: as considerações éticas e de privacidade levantadas pelo sistema foram identificadas e antecipadas",
  sol_linked_caps: "Capacidades ligadas (com lacunas)",
  sol_addressed_gaps: "Lacunas de capacidade abordadas",
  sol_no_gaps:
    "Ainda não foram identificadas lacunas de capacidade. Vá ao Passo 1 para avaliar capacidades.",
  sol_compliance_title: "Verificações de conformidade",
  sol_status: "Estado",
  sol_pass: "Conforme",
  sol_partial: "Parcial",
  sol_fail: "Não conforme",
  sol_na: "N/A",
  sol_not_applicable: "Não aplicável",
  sol_user_needs_title: "Avaliação das necessidades dos utilizadores",
  sol_operational_needs_title: "Avaliação das necessidades operacionais",
  sol_organisational_needs_title: "Avaliação das necessidades organizacionais",
  sol_expected_impact_title: "Avaliação do impacto esperado",
  sol_question: "Pergunta",
  sol_response: "Resposta",
  UN01: "A solução é fácil de utilizar?",
  UN02: "É provável que a solução funcione adequadamente sob pressão? Incluindo robustez e fiabilidade.",
  UN03: "É provável que a solução seja aceite pelos utilizadores?",
  UN04: "É provável que a solução apoie a compreensibilidade para os utilizadores?",
  UN05: "É provável que a solução apoie a explicabilidade para os utilizadores?",
  UN06: "É provável que a solução melhore a eficiência dos utilizadores?",
  UN07: "É provável que a solução melhore a eficácia dos utilizadores?",
  UN08: "É provável que a solução forneça conhecimento adicional?",
  UN09: "É provável que a solução produza consistentemente intervenções e/ou resultados positivos?",
  ON01: "É provável que a solução requeira formação (re-)extensiva?",
  ON02: "É provável que a solução requeira manutenção e suporte excessivos?",
  ON03: "É provável que a solução seja compatível com os seus métodos operacionais/POP?",
  ON04: "A solução é interoperável?",
  ON05: "É provável que a solução seja adaptável e transferível para os seus cenários operacionais?",
  ON06: "É provável que a solução apoie a saúde e segurança dos intervenientes?",
  ON07: "É provável que a solução alcance a população-alvo pretendida?",
  ON08: "É provável que a solução ofereça melhor eficiência operacional?",
  ON09: "É provável que a solução ofereça melhor eficácia operacional?",
  OG01: "É provável que a solução tenha um balanço custo-benefício positivo?",
  OG02: "A solução parece viável? Incluindo tecnologicamente, economicamente, legalmente, operacionalmente e em termos de calendário.",
  OG03: "É provável que a solução seja compatível com a cultura organizacional?",
  OG04: "É provável que a solução seja compatível com o mandato da sua organização?",
  OG05: "É provável que a solução seja compatível com as prioridades da governação da gestão de crises?",
  OG06: "O uso da solução apoiaria a sua reputação junto do público?",
  OG07: "O uso da solução ajudaria a melhorar as relações com a comunidade?",
  EI01: "A solução será aplicada no contexto dos cuidados de saúde humanos?",
  EI02: "A solução envolve o tratamento de dados pessoais?",
  EI03: "É provável que a solução tenha um impacto negativo nos direitos e liberdades de indivíduos e grupos? Por ex. privacidade, dignidade, autonomia, solidariedade.",
  EI04: "É provável que a solução tenha um impacto negativo em termos de justiça social e igualdade?",
  EI05: "É provável que a solução tenha um impacto negativo no bem-estar de indivíduos ou grupos?",
  EI06: "É provável que a solução aumente a vulnerabilidade de indivíduos ou grupos?",
  EI07: "É provável que a solução apresente riscos potenciais de segurança?",
  EI08: "É provável que a solução tenha um impacto negativo no ambiente?",
  EI09: "Existe uma incerteza SIGNIFICATIVA relativamente aos impactos legais, éticos e sociais do uso da solução?",
  CC01: "Segurança (ciber)",
  CC02: "Interoperabilidade",
  CC03: "Regulamento de IA",
  CC04: "Envolvimento comunitário",
  CC05: "RGPD",
  CC06: "Direitos fundamentais",
  CC07: "Objetivos de desenvolvimento sustentável",
  CC08: "Prioridades nacionais de gestão de crises",
  CC09: "Normas específicas do setor",
  CC10: "Leis e regulamentos específicos do setor",
  cap_add_from_ref: "Adicionar capacidades a partir da referência",
  cap_all_selected:
    "Todas as capacidades de referência foram adicionadas à sua sessão.",
  cap_add_selected: "Adicionar capacidades selecionadas",
  cap_ref_panel_title: "Capacidades disponíveis (modelo de referência DASF)",
  collapse: "Recolher",
  step0_abbr: "Passo 0: I&P",
  step0_desc:
    "Identificar os tipos de ameaças relevantes para o contexto de avaliação.",
  step1_abbr: "Passo 1: ANL",
  step1_desc:
    "Avaliar capacidades, identificar lacunas e necessidades de melhoria.",
  step2_abbr: "Passo 2: AS",
  step2_desc: "Avaliar soluções para as lacunas de capacidade identificadas.",
  step3_abbr: "Passo 3: RT",
  step3_desc: "Planear o roteiro de implementação e compromissos.",
  landing_attribution:
    "O DIREKTION recebeu financiamento do programa de investigação e inovação Horizonte Europa da União Europeia ao abrigo do acordo de subvenção n.º 101121249.",
  landing_developed_by: "Desenvolvido por",
  landing_as_part_of: "no âmbito do",
  landing_project: "projeto.",
  dasf_purpose_title: "Objetivo do DASF",
  dasf_purpose_p1:
    "O DIREKTION Assessment and Screening Framework (DASF) é um método central desenvolvido no âmbito do projeto DIREKTION para apoiar um processo de triagem e avaliação transparente e imparcial.",
  dasf_purpose_offers: "O framework DASF oferece um método passo a passo para:",
  dasf_purpose_item1: "Identificar e colmatar lacunas de capacidades",
  dasf_purpose_item2:
    "Implementar uma triagem sistemática de tecnologias e soluções",
  dasf_purpose_item3: "Estabelecer um roteiro",
  dasf_purpose_p2:
    "O DASF fornece a base para um processo sustentável de programação da investigação, garantindo que os intervenientes e as partes interessadas tenham acesso às ferramentas mais eficazes e atualizadas para a preparação e resposta a catástrofes. O conjunto completo destina-se a ser executado regularmente — por exemplo, uma vez por ano ou uma vez a cada quatro anos — para obter uma visão atualizada das necessidades de capacidades mais atuais, das lacunas de capacidades, das soluções potenciais e para atualizar regularmente o roteiro para as oportunidades de investigação da UE ou nacionais.",
  landing_assessment_process: "Processo de avaliação",
  landing_video_tutorial: "Veja o tutorial em vídeo no YouTube",
  landing_funded_by: "Financiado pela União Europeia",
  landing_trilateral_attribution:
    "Para a criação desta ferramenta, foram utilizadas contribuições essenciais da Trilateral Research, desenvolvidas no âmbito do DIREKTION D1.2.",
  delete_session_confirm: "Eliminar sessão: {name}?",
  delete_session_warning: "Esta ação não pode ser revertida. Tem a certeza?",
  N01: "Terramoto",
  N02: "Tsunami",
  N03: "Erupção vulcânica",
  N04: "Deslizamento de terra / Avalanche",
  N05: "Inundação",
  N06: "Cheia súbita",
  N07: "Tempestade / Furacão / Tornado",
  N08: "Incêndio florestal",
  N09: "Temperatura extrema (calor/frio)",
  N10: "Seca",
  N11: "Epidemia / Pandemia",
  N12: "Surto de doença animal",
  N13: "Infestação de insetos",
  T01: "Acidente industrial (QBRN)",
  T02: "Incidente nuclear / Radiológico",
  T03: "Acidente de transporte (aéreo)",
  T04: "Acidente de transporte (ferroviário)",
  T05: "Acidente de transporte (rodoviário)",
  T06: "Acidente de transporte (marítimo)",
  T07: "Gasoduto / Explosão de gás",
  T08: "Colapso de edifício / estrutura",
  T09: "Falha de barragem / dique",
  T10: "Corte de energia / Falha da rede",
  T11: "Falha de telecomunicações",
  T12: "Contaminação do abastecimento de água",
  T13: "Derrame de materiais perigosos",
  A01: "Ataque terrorista (explosivo)",
  A02: "Ataque terrorista (QBRN)",
  A03: "Ataque cibernético",
  A04: "Atirador ativo / Agressão armada",
  A05: "Sabotagem de infraestrutura crítica",
  A06: "Reféns / Sequestro",
  A07: "Distúrbios civis / Motins",
  A08: "Pirataria marítima / Desvio",
  A09: "Ataque com drones",
  A10: "Ameaça híbrida",
  A11: "Campanha de desinformação",
  A12: "Perturbação da cadeia de abastecimento (intencional)",
  A13: "Incêndio criminoso",
  "Cat-01": "Mitigação / Prevenção",
  "Cat-02": "Preparação",
  "Cat-03": "Resposta",
  "Cat-04": "Recuperação",
  "Mit-01": "Avaliação de riscos",
  "Mit-02": "Redução da exposição",
  "Mit-03": "Apoio à mitigação",
  "Prep-01": "Desenvolvimento de capacidades",
  "Prep-02": "Monitorização",
  "Prep-03": "Apoio à preparação",
  "Rsp-01": "Supressão do incidente",
  "Rsp-02": "Operações de socorro",
  "Rsp-03": "Segurança / Aplicação da lei",
  "Rsp-04": "Cuidados de saúde de emergência",
  "Rsp-05": "Comunicação para a sociedade",
  "Rsp-06": "Proteção da população / animais",
  "Rsp-07": "Limpeza da zona sinistrada",
  "Rsp-08": "Fornecimento de necessidades básicas",
  "Rsp-09": "Apoio à resposta",
  "Rec-01": "Recuperação humanitária",
  "Rec-02": "Recuperação ambiental",
  "Rec-03": "Recuperação económica",
  "Rec-04": "Restabelecimento de infraestruturas",
  "Rec-05": "Apoio à recuperação",
  "Mit-RA-01": "Identificação de riscos",
  "Mit-RA-02": "Análise de riscos",
  "Mit-RA-03": "Avaliação de riscos",
  "Mit-ER-01": "Proteção de bens",
  "Mit-ER-02": "Proteção de recursos naturais",
  "Mit-ER-03": "Sensibilização",
  "Mit-MS-01": "Análise de tendências",
  "Mit-MS-02": "Monitorização e revisão",
  "Prep-CD-01": "Planeamento de resposta e recuperação",
  "Prep-CD-02": "Formação",
  "Prep-CD-03": "Comunicação de riscos",
  "Prep-MO-01": "Deteção",
  "Prep-MO-02": "Alerta",
  "Prep-PS-01": "Gestão de pessoal",
  "Prep-PS-02": "Gestão de ativos",
  "Prep-PS-03": "Estabelecimento de cooperação",
  "Prep-EH-04": "Cuidados psicológicos",
  "Resp-SI-01": "Combate a incêndios - Infraestruturas",
  "Resp-SI-02": "Combate a incêndios - Natureza",
  "Resp-SI-03": "Controlo de inundações",
  "Resp-SI04": "Controlo de materiais perigosos (QBRN-E)",
  "Resp-RO-01": "Busca e Salvamento (SAR)",
  "Resp-RO-02": "Tratamento de vítimas no local",
  "Resp-RO-03": "Transporte de vítimas",
  "Resp-SL-01": "Segurança de locais / pessoas",
  "Resp-SL-02": "Identificação de pessoas",
  "Resp-SL-03": "Medicina legal",
  "Resp-SL-04": "Manutenção da ordem pública",
  "Resp-SL-05": "Gestão de tráfego",
  "Resp-EH-01": "Cuidados urgentes - Hospitais",
  "Resp-EH-02": "Quarentena",
  "Resp-EH-03": "Saúde pública em massa",
  "Resp-CS-01": "Aviso",
  "Resp-CS-02": "Comunicação de crise",
  "Resp-SF-01": "Evacuação",
  "Resp-SF-02": "Abrigo",
  "Resp-SF-03": "Reunificação",
  "Resp-DA-01": "Remoção de escombros",
  "Resp-DA-02": "Descontaminação de objetos",
  "Resp-DA-03": "Drenagem",
  "Resp-DA-04": "Abate de animais",
  "Resp-BN-01": "Fornecimento de água potável",
  "Resp-BN-02": "Fornecimento de alimentos",
  "Resp-BN-03": "Fornecimento de energia",
  "Resp-BN-04": "Fornecimento de TIC / Telecomunicações",
  "Resp-BN-05": "Saneamento",
  "Resp-RS-01": "Comando, Controlo e Coordenação",
  "Resp-RS-02": "Avaliação da situação",
  "Resp-RS-03": "Gestão de informação",
  "Resp-RS-04": "Monitorização / Recolha de dados",
  "Resp-RS-05": "Apoio a operações no local",
  "Resp-RS-06": "Logística",
  "Rec-HR-01": "Saúde pública e segurança",
  "Rec-HR-02": "Alimentação e abrigo",
  "Rec-ER-01": "Gestão de resíduos",
  "Rec-ER-02": "Restauração de habitats",
  "Rec-EC-01": "Recuperação empresarial",
  "Rec-EC-02": "Recuperação financeira",
  "Rec-RI-01": "Restabelecimento do transporte",
  "Rec-RI-02": "Restabelecimento de serviços públicos",
  "Rec-RS-01": "Estabelecimento da organização de recuperação",
  "Rec-RS-02": "Programação da recuperação",
  "Goal-01": "Prevenir incidentes",
  "Goal-01_desc": "Prevenir catástrofes / situações de crise.",
  "Goal-02": "Minimizar perdas por ameaças",
  "Goal-02_desc": "Reduzir / evitar perdas por ameaças.",
  "Goal-03": "Ajudar as vítimas",
  "Goal-03_desc": "Assegurar assistência rápida e eficaz às vítimas.",
  "Goal-04": "Recuperação adequada",
  "Goal-04_desc": "Alcançar uma recuperação rápida e eficaz.",
  "TO-01": "Bombeiros / Proteção civil",
  "TO-02": "Polícia",
  "TO-03": "Cuidados de saúde de emergência",
  "TO-04": "Defesa",
  "TO-05": "Centro de comando",
  "TO-06": "Autoridades",
  "TO-07": "Infraestruturas críticas",
  "TO-08": "ONG",
  "TO-09": "Outros",
  "SH-01": "Bombeiros/Proteção civil",
  "SH-02": "Polícia",
  "SH-03": "Cuidados de saúde de emergência",
  "SH-04": "SAR",
  "SH-05": "Centro de comando ou despacho (112)",
  "SH-06": "Autoridades (ministérios, municípios)",
  "SH-07": "Defesa",
  "SH-08": "Serviços públicos",
  "SH-09": "Guarda costeira ou Segurança de fronteiras",
  "SH-10": "Operador de infraestruturas críticas",
  "SH-11": "ONG",
  "SH-12": "Outros (a descrever)",
  "Imp-1": "Nenhuma/Muito baixa",
  "Imp-2": "Baixa",
  "Imp-3": "Média",
  "Imp-4": "Bastante alta",
  "Imp-5": "Muito alta",
  "PA-1": "Eficácia",
  "PA-1_desc": "Qualidade dos resultados, pontualidade, resistência.",
  "PA-2": "Segurança dos profissionais",
  "PA-2_desc": "Segurança física e mental do pessoal envolvido.",
  "PA-3": "Eficiência",
  "PA-3_desc": "Relação entre custos e resultados.",
  "PSc-1": "Fraco",
  "PSc-2": "Insatisfatório",
  "PSc-3": "Moderado",
  "PSc-4": "Satisfatório",
  "PSc-5": "Bom",
  "Nat-01": "Tecnológico",
  "Nat-01_desc":
    "Ex. Tecnologias de deteção, comando e controlo, comunicações e coordenação, TIC.",
  "Nat-02": "Humano",
  "Nat-02_desc":
    "Ex. Quantidade de pessoal, competência do pessoal, formação e educação.",
  "Nat-03": "Organizacional",
  "Nat-03_desc":
    "Ex. Procedimentos, estrutura organizacional, aspetos financeiros, acordos.",
  "Nat-04": "Regulatório",
  "Nat-04_desc": "Ex. Aspetos legais, aspetos formais de normalização.",
  "Kn-01": "Desconhecido",
  "Kn-02": "Não",
  "Kn-03": "Sim",
  "ASc-01": "Muito baixo",
  "ASc-02": "Baixo",
  "ASc-03": "Moderado",
  "ASc-04": "Alto",
  "ASc-05": "Muito alto",
  "Cat-01_desc":
    "Objetivo: Tomar medidas para limitar a probabilidade e reduzir o impacto de um incidente, catástrofe ou crise.",
  "Cat-02_desc":
    "Objetivo: Desenvolver e manter a estrutura organizacional e as capacidades para realizar atividades de resposta e recuperação.",
  "Cat-03_desc": "Objetivo: Salvar vidas e limitar efeitos adversos.",
  "Cat-04_desc":
    "Objetivo: Reconstruir e restaurar a vida normal de forma eficiente.",
  "Mit-01_desc": "Identificação, análise e avaliação de riscos.",
  "Mit-02_desc":
    "Proteção de bens, recursos naturais e da sociedade em geral contra ameaças.",
  "Mit-03_desc": "Capacidades em apoio à mitigação / prevenção.",
  "Prep-01_desc":
    "Processo de desenvolvimento e manutenção das capacidades de gestão de crises necessárias.",
  "Prep-02_desc":
    "Determinar o estado de um ambiente ou situação para permitir a deteção de incidentes.",
  "Prep-03_desc": "Capacidades em apoio ao desenvolvimento de capacidades.",
  "Rsp-01_desc":
    "Atividades no local para parar ou conter a causa da catástrofe.",
  "Rsp-02_desc": "Atividades no local para salvar vidas.",
  "Rsp-03_desc":
    "Segurança de áreas/pessoas, identificação de pessoas, medicina legal.",
  "Rsp-04_desc": "Atividades externas para salvar vidas.",
  "Rsp-05_desc": "Aviso e comunicação de crise.",
  "Rsp-06_desc": "Evacuação controlada de pessoas e/ou animais.",
  "Rsp-07_desc": "Garantir acessibilidade e segurança na zona afetada.",
  "Rsp-08_desc":
    "Fornecimento e/ou restabelecimento de produtos básicos e serviços de vital importância.",
  "Rsp-09_desc":
    "Capacidades para ativar uma ou mais outras capacidades de resposta.",
  "Rec-01_desc":
    "Fornecimento de serviços de saúde pública, segurança e abrigo.",
  "Rec-02_desc": "Remoção de poluição e descontaminação.",
  "Rec-03_desc": "Recuperação económica e empresarial.",
  "Rec-04_desc": "Restauração de rotas de transporte e serviços essenciais.",
  "Rec-05_desc": "Capacidades necessárias para uma recuperação bem coordenada.",
  "Mit-RA-01_desc":
    "Processo de pesquisa, reconhecimento e descrição de riscos.",
  "Mit-RA-02_desc":
    "Processo para compreender a natureza do risco e determinar o nível de risco.",
  "Mit-RA-03_desc":
    "Processo de comparação dos resultados da análise de riscos com critérios de risco para determinar se o risco é aceitável ou tolerável.",
  "Mit-ER-01_desc": "Proteção de bens (incluindo infraestruturas críticas).",
  "Mit-ER-02_desc":
    "Ações que minimizam as perdas por ameaças e preservam ou restauram as funções dos sistemas naturais.",
  "Mit-ER-03_desc":
    "Educação pública e sensibilização sobre ameaças e potenciais formas de as mitigar.",
  "Mit-MS-01_desc": "Investigação da evolução dos riscos.",
  "Mit-MS-02_desc":
    "Garantir que os controlos são eficazes e eficientes, obtendo informações adicionais para melhorar a avaliação de riscos.",
  "Prep-CD-01_desc":
    "Desenvolver, compilar e manter procedimentos e informações prontos para uso num incidente.",
  "Prep-CD-02_desc":
    "Atividades para facilitar a aprendizagem e desenvolvimento de conhecimentos, competências e capacidades para a resposta a catástrofes.",
  "Prep-CD-03_desc":
    "Comunicar e instruir o público sobre como estar bem preparado para uma crise e como se comportar quando ela ocorre.",
  "Prep-MO-01_desc": "Deteção de circunstâncias que se desviam do normal.",
  "Prep-MO-02_desc":
    "Alertar o pessoal para a presença de um incidente e permitir o início de ações de controlo.",
  "Prep-PS-01_desc":
    "Atividades para fornecer pessoal suficiente e qualificado para realizar tarefas de resposta e recuperação.",
  "Prep-PS-02_desc":
    "Atividades para fornecer equipamento, ferramentas, TIC e outros ativos necessários para resposta e recuperação.",
  "Prep-PS-03_desc":
    "Estabelecimento de cooperação internacional entre serviços de emergência e terceiros.",
  "Prep-EH-04_desc":
    "Cuidados de saúde psicológica a vítimas, familiares e outras pessoas afetadas pelo incidente.",
  "Resp-SI-01_desc":
    "Combate a incêndios em edifícios, zonas urbanizadas ou infraestruturas.",
  "Resp-SI-02_desc": "Combate a incêndios em ambientes naturais.",
  "Resp-SI-03_desc":
    "Gestão da água em caso de inundação por rotura de dique ou chuvas intensas.",
  "Resp-SI04_desc":
    "Parar o derrame de materiais perigosos, incluindo contenção (incidentes QBRN-E).",
  "Resp-RO-01_desc": "Operações de busca e salvamento.",
  "Resp-RO-02_desc": "Triagem, descontaminação e estabilização de vítimas.",
  "Resp-RO-03_desc":
    "Transporte de ambulância para zonas seguras ou hospitais.",
  "Resp-SL-01_desc":
    "Proteger áreas, infraestruturas e pessoas de partes não envolvidas.",
  "Resp-SL-02_desc": "Identificação de vítimas.",
  "Resp-SL-03_desc":
    "Atividades forenses para investigar a causa do incidente e salvaguardar evidências.",
  "Resp-SL-04_desc": "Controlo de motins, etc.",
  "Resp-SL-05_desc": "Controlo do tráfego de entrada e saída da zona afetada.",
  "Resp-EH-01_desc":
    "Serviço de saúde em hospitais regulares e/ou de campanha.",
  "Resp-EH-02_desc":
    "Isolamento de pessoas/vítimas potencialmente infecciosas.",
  "Resp-EH-03_desc":
    "Profilaxia em massa ou vacinação em caso de incidente nuclear ou pandemia.",
  "Resp-CS-01_desc":
    "Avisar a sociedade na zona ameaçada fornecendo informações oportunas e adequadas sobre a ameaça.",
  "Resp-CS-02_desc":
    "Fornecer informações sobre a catástrofe à sociedade, incluindo gestão de voluntários e apelos.",
  "Resp-SF-01_desc":
    "Evacuação controlada de pessoas e animais de uma zona ou edifício.",
  "Resp-SF-02_desc":
    "Fornecimento de abrigo a evacuados, incluindo nutrição e saneamento.",
  "Resp-SF-03_desc": "Reunificação de evacuados com os seus familiares.",
  "Resp-DA-01_desc": "Remoção de escombros e/ou material contaminado.",
  "Resp-DA-02_desc":
    "Descontaminação de zonas, infraestruturas e/ou veículos contaminados.",
  "Resp-DA-03_desc":
    "Drenagem e bombeamento de zonas ou infraestruturas inundadas.",
  "Resp-DA-04_desc": "Abate de animais potencialmente infetados.",
  "Resp-BN-01_desc": "Restauração ou fornecimento temporário de água potável.",
  "Resp-BN-02_desc": "Fornecimento temporário de alimentos.",
  "Resp-BN-03_desc":
    "Restauração do fornecimento de eletricidade/gás ou fornecimento de energia alternativa temporária.",
  "Resp-BN-04_desc":
    "Restauração ou fornecimento temporário de TIC e telecomunicações.",
  "Resp-BN-05_desc": "Restaurar o saneamento ou fornecer soluções temporárias.",
  "Resp-RS-01_desc":
    "Tomada de decisão, planeamento e atribuição de tarefas nos níveis de coordenação e comando durante um evento de catástrofe.",
  "Resp-RS-02_desc":
    "Desenvolvimento de informação operacional através do enriquecimento de dados recolhidos, incluindo quadro operacional comum.",
  "Resp-RS-03_desc":
    "Armazenamento e partilha de informações como dados recolhidos, avaliações e decisões tomadas.",
  "Resp-RS-04_desc":
    "Recolha de dados por monitorização física (vigilância) e mineração de dados.",
  "Resp-RS-05_desc":
    "Fornecimento de serviços básicos a primeiros intervenientes no local para possibilitar atividades de resposta.",
  "Resp-RS-06_desc":
    "Transporte de pessoal e material para apoiar operações prolongadas de resposta a catástrofes.",
  "Rec-HR-01_desc":
    "Fornecimento de serviços de saúde pública e segurança para os deslocados.",
  "Rec-HR-02_desc": "Fornecimento de alimentos e abrigo para os deslocados.",
  "Rec-ER-01_desc":
    "Remoção de poluição em grande escala e descontaminação, e gestão de resíduos.",
  "Rec-ER-02_desc": "Restauração de recursos naturais e habitats.",
  "Rec-EC-01_desc":
    "Recuperação empresarial de comércio e indústria afetados pela catástrofe.",
  "Rec-EC-02_desc": "Recuperação do impacto financeiro nas autoridades.",
  "Rec-RI-01_desc":
    "Restabelecimento de rotas de transporte (rodoviário, ferroviário, aquático, aéreo, gasodutos).",
  "Rec-RI-02_desc":
    "Restauração de serviços públicos interrompidos e outros serviços essenciais.",
  "Rec-RS-01_desc":
    "Estabelecimento da estrutura organizacional de recuperação para o curto e longo prazo.",
  "Rec-RS-02_desc":
    "Determinação e implementação do programa de recuperação com base na avaliação de impactos.",
  manage_capabilities: "Selecionar capacidades",
  select_capabilities_instr:
    "Selecione as capacidades que pretende avaliar quanto a lacunas.",
  drawer_hazards: "Ameaças",
  drawer_gaps: "Lacunas",
  drawer_solutions: "Soluções",
  drawer_roadmap: "Roteiro",
  drawer_capabilities: "Capacidades",
  drawer_solution: "Solução",
  drawer_with_gaps: "com lacunas",
  drawer_no_linked_caps: "Sem capacidades ligadas",
  drawer_add_to_roadmap: "Adicionar ao roteiro →",
  drawer_go_to_solutions: "Ir para soluções →",
  drawer_go_to_roadmap: "Ir para o roteiro →",
  drawer_none: "Nenhum",
  drawer_relevant_hazards: "Ameaças relevantes",
  action_priority: "Prioridade de ação",
  action_priority_instr:
    "Avalie a sua disposição para agir na melhoria desta capacidade (1 = baixa, 5 = urgente)",
  action_priority_label_1: "Agora não",
  action_priority_label_3: "Talvez",
  action_priority_label_5: "Urgente",
  prev_cap: "Anterior",
  next_cap: "Seguinte",
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

O conjunto de ferramentas DASF apoia o processo sistemático de avaliação e triagem para gestão de catástrofes. Fornece uma abordagem estruturada em 4 passos:

1. **Iniciação e Preparação (I&P)**: Identifique os tipos de perigo relevantes e defina o âmbito da avaliação.
2. **Avaliação de Necessidades e Lacunas (ANL)**: Avalie capacidades no ciclo de gestão de catástrofes, identifique lacunas e necessidades de melhoria.
3. **Avaliação de Soluções (AS)**: Avalie soluções potenciais para lacunas de capacidade identificadas, incluindo conformidade, necessidades dos utilizadores e avaliação de impacto.
4. **Roteiro (RT)**: Planeie cronogramas de implementação e compromissos para soluções selecionadas.

##### Primeiros Passos

- Crie ou abra uma sessão de avaliação a partir da página inicial
- Navegue pelos 4 passos usando os ícones da barra de ferramentas
- Alterne entre as funções de Utilizador e Editor usando o seletor abaixo

##### Funções

- **Utilizador Regular**: Pode preencher avaliações e visualizar resultados
- **Moderador**: Pode editar a configuração do framework (tipos de perigo, capacidades, partes interessadas)
- **Administrador**: Pode modificar escalas de avaliação e configurações

##### Contexto

Este projeto recebeu financiamento do programa de pesquisa e inovação Horizon 2020 da União Europeia. Desenvolvido pela TNO como parte do projeto [DIREKTION](https://www.direktion-network.org).`,

  // ── Collaboration (EN fallback) ────────────────────────────────────────────
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  FACILITATOR: "Facilitator",
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Concluido - Enviar resultados",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
};
